export default function getAppURL(){
return [
    window.location.protocol,
    "//",
    window.location.host,
    window.location.pathname
  ].join("");
}